import React from 'react';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import { Container, InfoIcon } from './styles';

function Tooltip({ content, placement = 'top', theme = 'dark', ...props }) {
  const isDarkTheme = localStorage.getItem('tema') === 'E';

  return (
    <Tippy
      content={content}
      placement={placement}
      theme={theme}
      arrow={true}
      interactive={false}
      delay={[200, 0]}
      duration={[200, 150]}
      {...props}
    >
      <Container>
        <InfoIcon className="material-icons" isDarkTheme={isDarkTheme}>
          info
        </InfoIcon>
      </Container>
    </Tippy>
  );
}

export default Tooltip;
